// Arabic translations - moved outside i18n folder to avoid babel-plugin-formatjs processing
const arMessages = {
  // Login page
  "login.page.title": "تسجيل الدخول | {siteName}",
  "login.user.identity.label": "اسم المستخدم أو البريد الإلكتروني",
  "login.password.label": "كلمة المرور",
  "sign.in.button": "تسجيل الدخول",
  "forgot.password": "نسيت كلمة المرور",
  "institution.login.button": "بيانات اعتماد المؤسسة/الحرم الجامعي",
  "institution.login.page.title": "تسجيل الدخول ببيانات اعتماد المؤسسة/الحرم الجامعي",
  "institution.login.page.sub.heading": "اختر مؤسستك من القائمة أدناه",
  "non.compliant.password.title": "لقد قمنا مؤخرًا بتغيير متطلبات كلمة المرور",
  "non.compliant.password.message": "كلمة المرور الحالية الخاصة بك لا تستوفي متطلبات الأمان الجديدة. لقد أرسلنا للتو رسالة إعادة تعيين كلمة المرور إلى عنوان البريد الإلكتروني المرتبط بهذا الحساب. شكرًا لك على مساعدتنا في الحفاظ على أمان بياناتك.",
  "account.locked.out.message.1": "لحماية حسابك، تم قفله مؤقتًا. حاول مرة أخرى بعد 30 دقيقة.",
  "username.or.email.format.validation.less.chars.message": "يجب أن يحتوي اسم المستخدم أو البريد الإلكتروني على حرفين على الأقل.",
  "email.validation.message": "أدخل اسم المستخدم أو البريد الإلكتروني",
  "password.validation.message": "أدخل كلمة المرور",
  "account.activation.success.message.title": "نجح! لقد قمت بتفعيل حسابك.",
  "account.activation.success.message": "سوف تتلقى الآن تحديثات وتنبيهات عبر البريد الإلكتروني منا تتعلق بالدورات التي سجلت فيها. قم بتسجيل الدخول للمتابعة.",
  "account.activation.info.message": "تم تفعيل هذا الحساب بالفعل.",
  "account.activation.error.message.title": "تعذر تفعيل حسابك",
  "account.activation.support.link": "اتصل بالدعم",
  "account.confirmation.success.message.title": "نجح! لقد قمت بتأكيد بريدك الإلكتروني.",
  "account.confirmation.success.message": "قم بتسجيل الدخول للمتابعة.",
  "account.confirmation.info.message": "تم تأكيد هذا البريد الإلكتروني بالفعل.",
  "account.confirmation.error.message.title": "تعذر تأكيد بريدك الإلكتروني",
  "tpa.account.link": "حساب {provider}",
  "internal.server.error.message": "حدث خطأ. حاول تحديث الصفحة، أو تحقق من اتصالك بالإنترنت.",
  "login.rate.limit.reached.message": "عدد كبير جدًا من محاولات تسجيل الدخول الفاشلة. حاول مرة أخرى لاحقًا.",
  "login.failure.header.title": "لم نتمكن من تسجيل دخولك.",
  "contact.support.link": "اتصل بدعم {platformName}",
  "login.incorrect.credentials.error": "اسم المستخدم أو البريد الإلكتروني أو كلمة المرور التي أدخلتها غير صحيحة. يرجى المحاولة مرة أخرى.",
  "login.form.invalid.error.message": "يرجى ملء الحقول أدناه.",
  "login.incorrect.credentials.error.reset.link.text": "إعادة تعيين كلمة المرور",
  "login.incorrect.credentials.error.before.account.blocked.text": "انقر هنا لإعادة تعيينها.",
  "password.security.nudge.title": "أمان كلمة المرور",
  "password.security.block.title": "مطلوب تغيير كلمة المرور",
  "password.security.nudge.body": "اكتشف نظامنا أن كلمة المرور الخاصة بك عرضة للاختراق. نوصي بتغييرها حتى يظل حسابك آمنًا.",
  "password.security.block.body": "اكتشف نظامنا أن كلمة المرور الخاصة بك عرضة للاختراق. قم بتغيير كلمة المرور الخاصة بك حتى يظل حسابك آمنًا.",
  "password.security.close.button": "إغلاق",
  "password.security.redirect.to.reset.password.button": "إعادة تعيين كلمة المرور",
  "login.tpa.authentication.failure": "نأسف، أنت غير مصرح لك بالوصول إلى {platform_name} عبر هذه القناة. يرجى الاتصال بمسؤول التعلم أو المدير الخاص بك للوصول إلى {platform_name}.{lineBreak}{lineBreak}تفاصيل الخطأ:{lineBreak}{errorMessage}",
  "logistration.sign.in": "تسجيل الدخول",
  "logistration.register.link.prefix": "ليس لديك حساب؟",
  "logistration.register.link.text": "سجل الآن",
  "login.email.help.text": "البريد الإلكتروني الذي استخدمته للتسجيل في {platformName}",
  "logistration.remember.me": "تذكرني",
  "forgot.password.prefix": "نسيت كلمة المرور؟",
  "forgot.password.link.text": "اضغط هنا",
  "logistration.social.login.title": "أو سجل الدخول باستخدام",

  // Register page
  "register.page.title": "التسجيل | {siteName}",
  "registration.fullname.label": "الاسم بالإنجليزية",
  "registration.fullname.ar.label": "الاسم بالعربية",
  "help.text.name.ar": "أدخل اسمك الكامل باللغة العربية.",
  "registration.email.label": "البريد الإلكتروني",
  "registration.username.label": "اسم المستخدم العام",
  "registration.password.label": "كلمة المرور",
  "registration.country.label": "البلد/المنطقة",
  "registration.opt.in.label": "أوافق على أن {siteName} قد يرسل لي رسائل تسويقية.",
  "help.text.name": "سيتم استخدام هذا الاسم في أي شهادات تحصل عليها.",
  "help.text.username.1": "الاسم الذي سيحدد هويتك في دوراتك.",
  "help.text.username.2": "لا يمكن تغيير هذا لاحقًا.",
  "help.text.email": "لتفعيل الحساب والتحديثات الهامة",
  "create.account.for.free.button": "إنشاء حساب مجاني",
  "create.account.cta.button": "{label}",
  "register.institution.login.page.title": "التسجيل ببيانات اعتماد المؤسسة/الحرم الجامعي",
  "empty.name.field.error": "أدخل اسمك الكامل",
  "empty.email.field.error": "أدخل بريدك الإلكتروني",
  "empty.username.field.error": "يجب أن يتراوح اسم المستخدم بين 2 و 30 حرفًا",
  "empty.password.field.error": "لم يتم استيفاء معايير كلمة المرور",
  "empty.country.field.error": "حدد بلدك أو منطقة إقامتك",
  "invalid.country.field.error": "يجب أن يتطابق البلد مع خيار متاح في القائمة المنسدلة.",
  "email.do.not.match": "عناوين البريد الإلكتروني غير متطابقة.",
  "email.invalid.format.error": "أدخل عنوان بريد إلكتروني صالح",
  "username.validation.message": "يجب أن يتراوح اسم المستخدم بين 2 و 30 حرفًا",
  "name.validation.message": "أدخل اسمًا صالحًا",
  "name.en.validation.message": "يجب أن يحتوي الاسم على حروف إنجليزية فقط",
  "name.ar.validation.message": "يجب أن يحتوي الاسم على حروف عربية فقط",
  "username.format.validation.message": "يمكن أن تحتوي أسماء المستخدمين على أحرف فقط (A-Z، a-z)، وأرقام (0-9)، وشرطات سفلية (_)، وواصلات (-). لا يمكن أن تحتوي أسماء المستخدمين على مسافات",
  "registration.request.failure.header": "لم نتمكن من إنشاء حسابك.",
  "registration.empty.form.submission.error": "يرجى التحقق من إجاباتك والمحاولة مرة أخرى.",
  "registration.request.server.error": "حدث خطأ. حاول تحديث الصفحة، أو تحقق من اتصالك بالإنترنت.",
  "registration.rate.limit.error": "عدد كبير جدًا من محاولات التسجيل الفاشلة. حاول مرة أخرى لاحقًا.",
  "registration.tpa.session.expired": "انتهت مهلة التسجيل باستخدام {provider}.",
  "registration.forbidden.username": "لا يمكن أن تتضمن أسماء المستخدمين كلمات قد يُخطئ في اعتبارها أدوار الدورة. يرجى اختيار اسم مستخدم مختلف.",
  "registration.tpa.authentication.failure": "نأسف، أنت غير مصرح لك بالوصول إلى {platform_name} عبر هذه القناة. يرجى الاتصال بمسؤول التعلم أو المدير الخاص بك للوصول إلى {platform_name}.{lineBreak}{lineBreak}تفاصيل الخطأ:{lineBreak}{errorMessage}",
  "terms.of.service.and.honor.code": "شروط الخدمة وقواعد الشرف",
  "privacy.policy": "سياسة الخصوصية",
  "honor.code": "قواعد الشرف",
  "terms.of.service": "شروط الخدمة",
  "registration.username.suggestion.label": "مقترح:",
  "did.you.mean.alert.text": "هل تقصد",

  // Reset password
  "reset.password.page.title": "إعادة تعيين كلمة المرور | {siteName}",
  "reset.password": "إعادة تعيين كلمة المرور",
  "reset.password.page.instructions": "أدخل كلمة المرور الجديدة وأكدها.",
  "new.password.label": "كلمة المرور الجديدة",
  "confirm.password.label": "تأكيد كلمة المرور",
  "passwords.do.not.match": "كلمات المرور غير متطابقة",
  "confirm.your.password": "أكد كلمة المرور",
  "reset.password.failure.heading": "لم نتمكن من إعادة تعيين كلمة المرور.",
  "reset.password.form.submission.error": "يرجى التحقق من إجاباتك والمحاولة مرة أخرى.",
  "reset.server.rate.limit.error": "طلبات كثيرة جدًا.",
  "reset.password.success.heading": "اكتملت إعادة تعيين كلمة المرور.",
  "reset.password.success": "تم إعادة تعيين كلمة المرور الخاصة بك. قم بتسجيل الدخول إلى حسابك.",
  "internal.server.error": "حدث خطأ. حاول تحديث الصفحة، أو تحقق من اتصالك بالإنترنت.",
  "rate.limit.error": "حدث خطأ بسبب كثرة الطلبات. يرجى المحاولة مرة أخرى بعد بعض الوقت.",
  "sign.in": "تسجيل الدخول",

  // Common components
  "show.password": "إظهار كلمة المرور",
  "hide.password": "إخفاء كلمة المرور",
  "one.letter": "حرف واحد",
  "one.number": "رقم واحد",
  "eight.characters": "8 أحرف",
  "password.sr.only.helping.text": "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل، وحرف واحد على الأقل، ورقم واحد على الأقل",
  "tpa.alert.heading": "على وشك الانتهاء!",
  "login.third.party.auth.account.not.linked": "لقد قمت بتسجيل الدخول بنجاح إلى {currentProvider}، ولكن حساب {currentProvider} الخاص بك لا يحتوي على حساب {platformName} مرتبط. لربط حساباتك، قم بتسجيل الدخول الآن باستخدام كلمة مرور {platformName} الخاصة بك.",
  "register.third.party.auth.account.not.linked": "لقد قمت بتسجيل الدخول بنجاح إلى {currentProvider}! نحتاج فقط إلى مزيد من المعلومات قبل أن تبدأ التعلم مع {platformName}.",
  "registration.using.tpa.form.heading": "أكمل إنشاء حسابك",
  "supportTitle": "دعم edX",
  "selectTicketForm": "يرجى اختيار نوع طلبك:",
  "registration.other.options.heading": "أو سجل باستخدام:",
  "login.other.options.heading": "أو سجل الدخول باستخدام:",
  "enterprise.login.btn.text": "بيانات اعتماد الشركة أو المدرسة",
  "logistration.register": "التسجيل",
  "enterprisetpa.title.heading": "هل ترغب في تسجيل الدخول باستخدام بيانات اعتماد {providerName} الخاصة بك؟",
  "enterprisetpa.login.button.text": "أظهر لي طرق أخرى لتسجيل الدخول أو التسجيل",
  "enterprisetpa.login.button.text.public.account.creation.disabled": "أظهر لي طرق أخرى لتسجيل الدخول",
  "sso.sign.in.with": "تسجيل الدخول باستخدام {providerName}",
  "sso.create.account.using": "إنشاء حساب باستخدام {providerName}",

  // Forgot password
  "forgot.password.page.title": "نسيت كلمة المرور | {siteName}",
  "forgot.password.page.heading": "إعادة تعيين كلمة المرور",
  "forgot.password.page.instructions": "يرجى إدخال عنوان بريدك الإلكتروني أدناه وسنرسل لك بريدًا إلكترونيًا يحتوي على تعليمات حول كيفية إعادة تعيين كلمة المرور الخاصة بك.",
  "forgot.password.page.invalid.email.message": "أدخل عنوان بريد إلكتروني صالح",
  "forgot.password.page.email.field.label": "البريد الإلكتروني",
  "forgot.password.page.submit.button": "إرسال",
  "forgot.password.error.alert.title": "لم نتمكن من الاتصال بك.",
  "forgot.password.error.message.title": "حدث خطأ.",
  "forgot.password.request.in.progress.message": "طلبك السابق قيد التنفيذ، يرجى المحاولة مرة أخرى بعد لحظات قليلة.",
  "forgot.password.empty.email.field.error": "أدخل بريدك الإلكتروني",
  "forgot.password.email.help.text": "عنوان البريد الإلكتروني الذي استخدمته للتسجيل في {platformName}",
  "confirmation.message.title": "تحقق من بريدك الإلكتروني",
  "confirmation.support.link": "اتصل بالدعم الفني",
  "need.help.sign.in.text": "هل تحتاج مساعدة في تسجيل الدخول؟",
  "additional.help.text": "للحصول على مساعدة إضافية، اتصل بدعم {platformName} على ",
  "sign.in.text": "تسجيل الدخول",
  "extend.field.errors": "{emailError} أدناه.",
  "invalid.token.heading": "رابط إعادة تعيين كلمة المرور غير صالح",
  "invalid.token.error.message": "رابط إعادة تعيين كلمة المرور هذا غير صالح. ربما تم استخدامه بالفعل. أدخل بريدك الإلكتروني أدناه لتلقي رابط جديد.",
  "token.validation.rate.limit.error.heading": "طلبات كثيرة جدًا",
  "token.validation.rate.limit.error": "حدث خطأ بسبب كثرة الطلبات. يرجى المحاولة مرة أخرى بعد بعض الوقت.",
  "token.validation.internal.sever.error.heading": "فشل التحقق من الرمز",
  "token.validation.internal.sever.error": "حدث خطأ. حاول تحديث الصفحة، أو تحقق من اتصالك بالإنترنت.",

  // Progressive profiling
  "progressive.profiling.page.title": "مرحبًا | {siteName}",
  "progressive.profiling.page.heading": "بعض الأسئلة لك ستساعدنا على أن نصبح أكثر ذكاءً.",
  "optional.fields.information.link": "تعرف على المزيد حول كيفية استخدامنا لهذه المعلومات.",
  "optional.fields.submit.button": "إرسال",
  "optional.fields.skip.button": "تخطي الآن",
  "optional.fields.next.button": "التالي",
  "continue.to.platform": "متابعة إلى {platformName}",
  "modal.title": "شكرًا لإعلامنا.",
  "modal.description": "يمكنك إكمال ملفك الشخصي في الإعدادات في أي وقت إذا غيرت رأيك.",
  "welcome.page.error.heading": "لم نتمكن من تحديث ملفك الشخصي",
  "welcome.page.error.message": "حدث خطأ. يمكنك إكمال ملفك الشخصي في الإعدادات في أي وقت.",

  // Recommendations
  "recommendation.page.title": "التوصيات | {siteName}",
  "recommendation.page.heading": "لدينا بعض التوصيات لمساعدتك على البدء.",
  "recommendation.skip.button": "تخطي الآن",
  "recommendation.option.trending": "رائج الآن",
  "recommendation.option.popular": "الأكثر شعبية",
  "recommendation.option.recommended.for.you": "موصى به لك",
  "recommendation.product-card.pill-text.course": "دورة",
  "recommendation.product-card.pill-text.professional-certificate": "شهادة احترافية",
  "recommendation.product-card.pill-text.emeritus": "مقدم على Emeritus",
  "recommendation.product-card.pill-text.shorelight": "مقدم من خلال Shorelight",
  "recommendation.product-card.footer-text.number-of-courses": "{length} {label}",
  "recommendation.product-card.footer-text.subscription": "اشتراك",
  "recommendation.product-card.launch-icon.sr-text": "يفتح رابطًا في علامة تبويب جديدة",

  // FormattedMessage replacements
  "login.inactive.user.error": "لتسجيل الدخول، تحتاج إلى تفعيل حسابك.{lineBreak}{lineBreak}لقد أرسلنا للتو رابط تفعيل إلى {email}. إذا لم تتلقَ بريدًا إلكترونيًا، تحقق من مجلد البريد العشوائي أو {supportLink}.",
  "allowed.domain.login.error": "بصفتك مستخدم {allowedDomain}، يجب عليك تسجيل الدخول باستخدام {tpaLink} الخاص بـ {allowedDomain}.",
  "login.incorrect.credentials.error.attempts.text.1": "اسم المستخدم أو البريد الإلكتروني أو كلمة المرور التي أدخلتها غير صحيحة. لديك {remainingAttempts} محاولات تسجيل دخول إضافية قبل قفل حسابك مؤقتًا.",
  "login.incorrect.credentials.error.attempts.text.2": "إذا نسيت كلمة المرور، {resetLink}",
  "account.locked.out.message.2": "لتكون في أمان، يمكنك {resetLink} قبل المحاولة مرة أخرى.",
  "login.incorrect.credentials.error.with.reset.link": "اسم المستخدم أو البريد الإلكتروني أو كلمة المرور التي أدخلتها غير صحيحة. يرجى المحاولة مرة أخرى أو {resetLink}.",
  "account.activation.error.message": "حدث خطأ ما، يرجى {supportLink} لحل هذه المشكلة.",
  "forgot.password.confirmation.message": "أرسلنا بريدًا إلكترونيًا إلى {email} يحتوي على تعليمات لإعادة تعيين كلمة المرور الخاصة بك. إذا لم تتلقَ رسالة إعادة تعيين كلمة المرور بعد دقيقة واحدة، تحقق من إدخال عنوان البريد الإلكتروني الصحيح، أو تحقق من مجلد البريد العشوائي. إذا كنت بحاجة إلى مساعدة إضافية، {supportLink}.",
  "error.notfound.message": "الصفحة التي تبحث عنها غير متاحة أو يوجد خطأ في عنوان URL. يرجى التحقق من عنوان URL والمحاولة مرة أخرى.",
  "register.page.terms.of.service.and.honor.code": "بإنشاء حساب، فإنك توافق على {tosAndHonorCode} وتقر بأن {platformName} وكل عضو يعالج بياناتك الشخصية وفقًا لـ {privacyPolicy}.",
  "register.page.honor.code": "أوافق على {platformName}\u00a0{tosAndHonorCode}",
  "register.page.terms.of.service": "أوافق على {platformName}\u00a0{termsOfService}",

  // Base container layouts
  "start.learning": "ابدأ التعلم",
  "with.site.name": "مع {siteName}",
  "your.career.turning.point": "نقطة التحول في مسيرتك المهنية",
  "is.here": "هنا.",
  "welcome.to.platform": "مرحبًا بك في {siteName}، {fullName}!",
  "complete.your.profile.1": "أكمل",
  "complete.your.profile.2": "ملفك الشخصي",
};

module.exports = arMessages;
